import React from "react";

import clsx from "clsx";

import DiscoverEnerfloButtonWithOverlay from "components/discover-enerflo-button-with-overlay";

import Heading from "../../heading";
import styles from "./index.module.css";

const DiscoverEnerflo = () => (
  <div className="space-y-6 md:space-y-10">
    <div>
      <div>
        <Heading tag="h4" className="text-center md:text-left">
          Discover Enerflo
        </Heading>
        <p className={styles.subheading}>
          Meet with one of our Platform Specialists for to learn about the platform, pricing and more.
        </p>
      </div>
      <address className="space-y-3 not-italic mt-2 md:mt-4">
        <div
          className={clsx(
            styles.contactItem,
            styles.itemPadding,
            "flex flex-col justify-between items-center sm:flex-row md:flex-col gap-4 gap-x-10"
          )}
        >
          <div className="sm:max-w-[50%] md:max-w-none">
            <p className={clsx(styles.infoLabel, "mb-2")}>Book a Meeting With a Platform Consultant</p>
            <p className="text-sm text-gray-400 font-light">
              Book a Discovery Call on a day and time that works best for you to find out if Enerflo is a good fit for
              your business.
            </p>
          </div>
          <div className="w-full sm:w-auto md:w-full">
            <DiscoverEnerfloButtonWithOverlay buttonClassName="w-full text-sm sm:text-base" />
            <p className="text-xs text-center mt-1 text-gray-400">All free. No risk. No obligation.</p>
          </div>
        </div>
        <div className={clsx(styles.contactItem, styles.itemPadding)}>
          <p className={styles.infoLabel}>For Sales & Marketing Inquiries Only (NOT for Support)</p>
          <a href="mailto:sales@enerflo.io" className="text-primary text-base md:text-lg block">
            sales@enerflo.io
          </a>
          <a href="tel:562-582-7728" className="text-primary text-base md:text-lg block">
            1 (562) 582-7728
          </a>
        </div>
      </address>
    </div>
    <div>
      <div>
        <Heading tag="h4" className="text-center md:text-left">
          Partner with Enerflo
        </Heading>
        <p className={styles.subheading}>
          Are you interested in integrating your product, service, or software with Enerflo? Contact Enerflo’s Business
          Development team.
        </p>
      </div>
      <address className="space-y-3 not-italic mt-2 md:mt-4">
        <div className={clsx(styles.contactItem, styles.itemPadding)}>
          <p className={styles.infoLabel}>Contact Business Development</p>
          <a href="mailto:bizdev@enerflo.io" className="text-primary text-base md:text-lg">
            bizdev@enerflo.io
          </a>
        </div>
      </address>
    </div>
  </div>
);

export default DiscoverEnerflo;
